import {get} from 'lodash'
import createModel from 'utils/model'
import {list, create, remove} from 'message-control/services/sensitive-words'

export default createModel({
    namespace: 'messageControl_sensitiveWords',

    state: {
        tableData: {},
    },

    effects: {
        *list(_, {select, call, put}) {
            const {tableData} = yield select(
                ({messageControl_sensitiveWords}) => messageControl_sensitiveWords,
            )

            const query = {
                offset: tableData.pagination.pageSize * (tableData.pagination.current - 1),
                limit: tableData.pagination.pageSize,
                ...tableData.params,
            }

            const res = yield call(list, query)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableData.dataSource = res.data
                    draft.tableData.pagination.total = get(res, 'pagination.rows_found', 0)
                },
            })
            return res
        },
        *create({payload}, {call}) {
            return yield call(create, payload)
        },
        *remove({payload}, {call}) {
            return yield call(remove, payload)
        },
    },

    reducers: {},
})
